import {atom, useAtomValue, useSetAtom} from 'jotai';
import {isEqual} from 'lodash';
import {useCallback, useEffect, useState} from 'react';
import {useLocation, useNavigate, useNavigationType} from 'react-router-dom';

const stackAtom = atom<string[]>([]);

export const useHistoryStack = () => {
  const setStack = useSetAtom(stackAtom);
  const {pathname} = useLocation();
  const type = useNavigationType();

  useEffect(() => {
    if (type === 'POP') {
      setStack((prev) => prev.slice(0, prev.length - 1));
    } else if (type === 'PUSH') {
      setStack((prev) => [...prev, pathname]);
    } else {
      setStack((prev) => [...prev.slice(0, prev.length - 1), pathname]);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, type]);
};

interface NavOptions {
  backPath?: string;
  removeSearch?: boolean;
}

export const useGoBack = (options?: NavOptions) => {
  const historyStack = useAtomValue(stackAtom);
  const location = useLocation();
  const [navOptions, setNavOptions] = useState<NavOptions | undefined>(options);
  const navigate = useNavigate();

  const goBack = useCallback(() => {
    if (historyStack.length) {
      navigate(-1);
    } else if (navOptions?.backPath) {
      const {backPath, removeSearch} = navOptions;

      navigate({
        pathname: backPath,
        search: removeSearch ? undefined : location.search,
      });
    }
  }, [historyStack.length, location.search, navOptions, navigate]);

  useEffect(() => {
    if (!isEqual(navOptions, options)) {
      setNavOptions(options);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options]);

  return goBack;
};
